export const schart = [
  ["H", "H", "H", "H", "H", "Ds", "S", "S", "BJ"],
  ["H", "H", "H", "H", "D", "Ds", "S", "S", "BJ"],
  ["H", "H", "D", "D", "D", "Ds", "S", "S", "BJ"],
  ["D", "D", "D", "D", "D", "Ds", "S", "S", "BJ"],
  ["D", "D", "D", "D", "D", "Ds", "Ds", "S", "BJ"],
  ["H", "H", "H", "H", "H", "S", "S", "S", "BJ"],
  ["H", "H", "H", "H", "H", "S", "S", "S", "BJ"],
  ["H", "H", "H", "H", "H", "H", "S", "S", "BJ"],
  ["H", "H", "H", "H", "H", "H", "S", "S", "BJ"],
  ["H", "H", "H", "H", "H", "H", "S", "S", "BJ"],
];
